import { useEffect } from 'react';
import { useAppDispatch } from './useAppDispatch';
import * as lookupSlice from '../data/lookup.slice';

/**
 * Ensures the given lookup tables are loaded.
 *
 * Declare the lookups a component reads right where it reads them, instead of
 * eagerly fetching everything in `Home` on boot. `fetchLookupItemsAsync` caches
 * per table, so calling this from several components is free: the first caller
 * triggers the request and the rest are no-ops.
 *
 * Pass an empty array to skip fetching — useful for gating on a dialog's `open`
 * flag so the lookup is only fetched once the user actually needs it:
 *
 *   useLookups(open ? ['applicationSetting'] : []);
 */
export const useLookups = (tableNames: string[]) => {
  const dispatch = useAppDispatch();
  // Callers pass array literals, so key the effect on the contents rather than
  // the array identity.
  const key = tableNames.join(',');

  useEffect(() => {
    if (!key) return;
    key.split(',').forEach((tableName) => {
      dispatch(lookupSlice.fetchLookupItemsAsync(tableName));
    });
  }, [key, dispatch]);
};
